module.exports = __webpack_public_path__ + "static/media/Banner.b7c7b6ad.png";